import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import { isHomePage } from "../utils/isHomePage";
import setupProductFavorites from "../pages/products/setupProductFavorites";
import setupProductAddToCart from "../pages/products/setupProductAddToCart";
// Import the refactored function
import { setupNotifyStockFeature } from "../pages/singleProduct/singleProduct";
import "swiper/css";
import "swiper/css/navigation";

export const initializeProductsSwiper = () => {
  const swiperElements = document.querySelectorAll(".products-swiper");

  if (swiperElements.length > 0) {
    swiperElements.forEach((element) => {
      // Check if swiper is already initialized
      if (element.swiper) return;

      new Swiper(element, {
        modules: [Navigation],
        navigation: {
          nextEl: element.querySelector(".swiper-button-next"),
          prevEl: element.querySelector(".swiper-button-prev"),
        },
        slidesPerView: 1,
        breakpoints: {
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
          2000: { slidesPerView: 4 },
        },
      });
    });

    // Initialize all product-related functionalities
    setupProductFavorites();
    setupProductAddToCart();
    setupNotifyStockFeature();
  }
};

// Initialize on DOM load
document.addEventListener("DOMContentLoaded", initializeProductsSwiper);

// Initialize on dynamic content load if on homepage
if (isHomePage()) {
  document.addEventListener("bottomContentLoaded", initializeProductsSwiper);
}
